import { useEffect, useState } from 'react';
import { stageSelector } from '../store/reducers/stageSlice/stageSlice';
import { charterSelector } from '../store/reducers/charterSlice/charterSlice';
import { positionSelector } from '../store/reducers/positionSlice/positionSlice';
import { getCountDays, getMoveDays, getUpdatePositions } from '../helpers/getCountDays';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useUpdateAll } from './useUpdateAll';
import { getChainConnection } from '../helpers/getChainConnection';

export const useMovePosition = (position, activeTab) => {
    const [positionX, setPositionX] = useState(0);
    const [needMoveUpdate, setNeedMoveUpdate] = useState(false);
    const allCharters = useSelector(charterSelector.selectAll);
    const allStage = useSelector(stageSelector.selectAll);
    const parentCharter = allCharters.find((charter) => charter.children.includes(position.guid));
    const parentStage = allStage.find((stage) => {
        const childGuid = parentCharter ? parentCharter.guid : position.guid;
        return stage.positions.includes(childGuid);
    });
    const { updateAll } = useUpdateAll(parentStage);

    const allPosition = useSelector(positionSelector.selectEntities);
    const handleMouseMove = (value) => {
        setPositionX((prevState) => prevState + value);
    };

    const handleMouseUp = () => {
        setNeedMoveUpdate(true);
    };

    useEffect(() => {
        if (needMoveUpdate) {
            const queue = [];
            let updatedPositionsEntities = { ...allPosition };

            const startDate = position.planned.start_date ? position.planned.start_date : '';

            const start_date = getCountDays(positionX, startDate, activeTab);
            const moveDays = getMoveDays(positionX, activeTab);

            if (moveDays !== 0) {
                const connectionsTypeOne = position.connections.filter(
                    (connection) => connection.type === 1
                );

                const isFollowerTypeOne = position.connections.some(
                    (connection) => connection.type === 1 && connection.to === position.guid
                );

                if (isFollowerTypeOne) {
                    const connections = position.connections.filter(
                        (connection) => connection.type === 1 && connection.to === position.guid
                    );

                    const firstPredecessorStartDate = connections
                        .map((connection) => updatedPositionsEntities[connection.from])
                        .sort(
                            (positionA, positionB) =>
                                moment(positionA.planned.end_date).valueOf() -
                                moment(positionB.planned.end_date).valueOf()
                        )[0].planned.start_date;

                    if (
                        position.planned.end_date ===
                            moment(firstPredecessorStartDate).add(-1, 'days').format() &&
                        moveDays > 0
                    ) {
                        setPositionX(0);

                        setNeedMoveUpdate(false);
                        return;
                    }

                    const updatedEndDate = moment(position.planned.end_date)
                        .add(moveDays, 'days')
                        .format();

                    if (
                        moment(updatedEndDate).isAfter(
                            moment(firstPredecessorStartDate).add(-1, 'days')
                        )
                    ) {
                        const end_date = moment(firstPredecessorStartDate).add(-1, 'days').format();

                        const start_date = moment(end_date)
                            .add(-Number(position.planned.days_count) + 1, 'days')
                            .format();

                        const planned = {
                            ...position.planned,
                            start_date,
                            end_date,
                        };

                        updatedPositionsEntities[position.guid] = {
                            ...position,
                            planned,
                        };
                        queue.push({
                            data: {
                                data: {
                                    guid: position.guid,
                                    startDate: moment(planned.start_date).format('YYYY-MM-DD'),
                                    endDate: moment(planned.end_date).format('YYYY-MM-DD'),
                                },
                                type: 'update',
                            },
                            subEntityType: 'step',
                            subEntityId: parentStage.id,
                            t: Date.now(),
                        });

                        updateAll(updatedPositionsEntities);
                        setPositionX(0);

                        setNeedMoveUpdate(false);
                        $.ajax({
                            url: queueable.serverQueueHandlerUrl,
                            type: 'POST',
                            dataType: 'text',
                            data: { q: JSON.stringify(queue), t: Date.now() },
                            success: function () {},
                            error: function (jqXHR, exception) {
                                console.log('Error with task. Message: ' + exception + '.');

                                queueable.clearAllKeysForEntity();
                                queueable.showServerErrorPopup();
                            },
                        });
                        return;
                    }
                }

                if (connectionsTypeOne.length) {
                    if (moveDays > 0) {
                        connectionsTypeOne.forEach((connection) => {
                            const currentPosition = updatedPositionsEntities[connection.to];
                            const planned = {
                                ...currentPosition.planned,
                                start_date: moment(currentPosition.planned.start_date)
                                    .add(moveDays, 'days')
                                    .format(),
                                end_date: moment(currentPosition.planned.end_date)
                                    .add(moveDays, 'days')
                                    .format(),
                            };

                            queue.push({
                                data: {
                                    data: {
                                        guid: currentPosition.guid,
                                        startDate: moment(planned.start_date).format('YYYY-MM-DD'),
                                        endDate: moment(planned.end_date).format('YYYY-MM-DD'),
                                    },
                                    type: 'update',
                                },
                                subEntityType: 'step',
                                subEntityId: parentStage.id,
                                t: Date.now(),
                            });

                            updatedPositionsEntities[currentPosition.guid] = {
                                ...currentPosition,
                                planned,
                            };
                        });
                    } else {
                        connectionsTypeOne.forEach((connection) => {
                            const currentPosition = updatedPositionsEntities[connection.to];
                            const diffBeforePosition =
                                moment(position.planned.start_date).diff(
                                    moment(currentPosition.planned.end_date),
                                    'days'
                                ) - 1;

                            if (diffBeforePosition - Math.abs(moveDays) < 0) {
                                const planned = {
                                    ...currentPosition.planned,
                                    start_date: moment(currentPosition.planned.start_date)
                                        .add(diffBeforePosition - Math.abs(moveDays), 'days')
                                        .format(),
                                    end_date: moment(currentPosition.planned.end_date)
                                        .add(diffBeforePosition - Math.abs(moveDays), 'days')
                                        .format(),
                                };

                                queue.push({
                                    data: {
                                        data: {
                                            guid: currentPosition.guid,
                                            startDate: moment(planned.start_date).format(
                                                'YYYY-MM-DD'
                                            ),
                                            endDate: moment(planned.end_date).format('YYYY-MM-DD'),
                                        },
                                        type: 'update',
                                    },
                                    subEntityType: 'step',
                                    subEntityId: parentStage.id,
                                    t: Date.now(),
                                });

                                updatedPositionsEntities[currentPosition.guid] = {
                                    ...currentPosition,
                                    planned,
                                };
                            }
                        });
                    }
                }

                const nextPositions = position.connections
                    .filter(
                        (connection) => connection.type === 0 && position.guid === connection.from
                    )
                    .map((connection) => allPosition[connection.to])
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.planned.end_date).valueOf() -
                            moment(positionB.planned.end_date).valueOf()
                    );

                const chainsConnections = nextPositions.map((position) => [
                    position,
                    ...getChainConnection(position, allPosition),
                ]);

                const days_count = position.planned.days_count;

                const endDate = moment(start_date)
                    .add(+days_count - 1, 'days')
                    .format();

                let planned = {
                    ...position.planned,
                    start_date,
                    end_date: endDate,
                };

                const prevPositions = position.connections
                    .filter(
                        (connection) => connection.type === 0 && connection.from !== position.guid
                    )
                    .map((connection) => updatedPositionsEntities[connection.from])
                    .sort(
                        (positionA, positionB) =>
                            moment(positionA.planned.end_date).valueOf() -
                            moment(positionB.planned.end_date).valueOf()
                    );

                if (prevPositions.length) {
                    const lastPrevPosition = prevPositions.slice(-1)[0];

                    if (
                        position.planned.start_date ===
                            moment(lastPrevPosition.planned.end_date).add(1, 'days').format() &&
                        moveDays < 0
                    ) {
                        setPositionX(0);
                        setNeedMoveUpdate(false);
                        return;
                    }

                    if (
                        moment(planned.start_date).isBefore(
                            moment(lastPrevPosition.planned.end_date).add(1, 'days')
                        )
                    ) {
                        planned = {
                            ...planned,
                            start_date: moment(lastPrevPosition.planned.end_date)
                                .add(1, 'days')
                                .format(),
                            end_date: moment(lastPrevPosition.planned.end_date)
                                .add(planned.days_count, 'days')
                                .format(),
                        };
                    }
                }

                const updatedPosition = { ...position, planned };

                queue.push({
                    data: {
                        data: {
                            guid: position.guid,
                            startDate: moment(planned.start_date).format('YYYY-MM-DD'),
                            endDate: moment(planned.end_date).format('YYYY-MM-DD'),
                        },
                        type: 'update',
                    },
                    subEntityType: 'step',
                    subEntityId: parentStage.id,
                    t: Date.now(),
                });

                if (chainsConnections.length) {
                    chainsConnections.forEach((chain) => {
                        const nextPosition = chain[0];

                        const initEndDate = position.planned.end_date;

                        const nextPositionStartDate = nextPosition.planned.start_date;

                        const diffBeforePosition =
                            moment(nextPositionStartDate).diff(moment(initEndDate), 'days') - 1;

                        if (diffBeforePosition - moveDays < 0) {
                            const diff = Math.abs(diffBeforePosition - moveDays);

                            const updatePosition = getUpdatePositions(chain, diff);

                            updatePosition.forEach((position) => {
                                queue.push({
                                    data: {
                                        data: {
                                            guid: position.changes.guid,
                                            startDate: moment(
                                                position.changes.planned.start_date
                                            ).format('YYYY-MM-DD'),
                                            endDate: moment(
                                                position.changes.planned.end_date
                                            ).format('YYYY-MM-DD'),
                                        },
                                        type: 'update',
                                    },
                                    subEntityType: 'step',
                                    subEntityId: parentStage.id,
                                    t: Date.now(),
                                });
                            });

                            updatedPositionsEntities[position.guid] = updatedPosition;

                            updatePosition.forEach((item) => {
                                updatedPositionsEntities[item.id] = item.changes;
                            });
                        }
                    });
                }

                updatedPositionsEntities[position.guid] = updatedPosition;
                $.ajax({
                    url: queueable.serverQueueHandlerUrl,
                    type: 'POST',
                    dataType: 'text',
                    data: { q: JSON.stringify(queue), t: Date.now() },
                    success: function () {},
                    error: function (jqXHR, exception) {
                        console.log('Error with task. Message: ' + exception + '.');

                        queueable.clearAllKeysForEntity();
                        queueable.showServerErrorPopup();
                    },
                });
                updateAll(updatedPositionsEntities);
            }

            setPositionX(0);
            setNeedMoveUpdate(false);
        }
    }, [needMoveUpdate]);

    return {
        positionX,
        handleMouseMove,
        handleMouseUp,
        needMoveUpdate,
    };
};
